import { createSelector } from '@ngrx/store';
import { selectEndUsersState } from 'src/app/core/reducers';
import { EndUsersState } from './end-users.reducer';

export const selectAllEndUserState = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state
);

export const selectEndUser = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.endUser
);
export const selectEndUserLines = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.lines
);
export const selectEndUserSelectedLine = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => {
    return state.selectedLine;
  }
);
export const selectEndUserSims = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.sims
);
export const selectEndUserDevices = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => {
    return state.devices;
  }
);
export const selectEndUserBrand = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.brand
);
export const selectEndUserIsLoading = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.isLoadingEndUser
);
export const selectEndUsersUserPlans = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.userPlans
);

export const selectEndUserSearchedParams = createSelector(
  selectEndUsersState,
  (state: EndUsersState) => state.searchedEndUserParams
);
